export default "__VITE_ASSET__z3yPvn05__"